module.exports = __webpack_public_path__ + "static/img/platform2.98bb3252.png";